import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';

class PermissionService {
  async listPermissions(params: { skip?: number; limit?: number; permission_name?: string; permission_key?: string } = {}) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.PERMISSIONS.LIST, params);
      return response.data;
    } catch (error) {
      console.error('Error fetching permissions:', error);
      throw error;
    }
  }

  async getPermissionsDropdown() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PERMISSIONS.DROPDOWN);
      return response.data;
    } catch (error) {
      console.error('Error fetching permissions dropdown:', error);
      throw error;
    }
  }

  async createPermission(data: any) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.PERMISSIONS.CREATE, data);
      return response.data;
    } catch (error) {
      console.error('Error creating permission:', error);
      throw error;
    }
  }

  async getPermissionByKey(key: string) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PERMISSIONS.GET_BY_KEY(key));
      return response.data;
    } catch (error) {
      console.error('Error fetching permission:', error);
      throw error;
    }
  }

  async updatePermission(key: string, data: any) {
    try {
      const response = await apiClient.patch(API_ENDPOINTS.PERMISSIONS.UPDATE(key), data);
      return response.data;
    } catch (error) {
      console.error('Error updating permission:', error);
      throw error;
    }
  }

  async deletePermission(key: string) {
    try {
      const response = await apiClient.delete(API_ENDPOINTS.PERMISSIONS.DELETE(key));
      return response.data;
    } catch (error) {
      console.error('Error deleting permission:', error);
      throw error;
    }
  }

  async assignPermissionsToRole(role_key: string, permissions: string[]) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.PERMISSIONS.ASSIGN_TO_ROLE, { role_key, permissions });
      return response.data;
    } catch (error) {
      console.error('Error assigning permissions to role:', error);
      throw error;
    }
  }

  async getRolePermissions(role_key: string) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PERMISSIONS.GET_ROLE_PERMISSIONS(role_key));
      return response.data;
    } catch (error) {
      console.error('Error fetching role permissions:', error);
      throw error;
    }
  }
}

export const permissionService = new PermissionService();
